/**
 * Copyright © Binary Anvil, Inc. All rights reserved.
 * See https://binaryanvil.com/software/license for license details.
 */
import {useRouter} from "next/router";
import React, {useEffect} from "react";
import {useAppSelector} from "@/app/hooks/redux";

declare global {
    interface Window {
        fbq?: (...args: any[]) => void;
        _fbq?: any;
    }
}

const MetaPixelCode = (props: {
    pixelCodeId?:string,
}) => {
    const router = useRouter();
    const {storeConfig} = useAppSelector(state => state.storeConfigReducer);

    const pixelId = props.pixelCodeId || storeConfig?.binaryanvil_headless_metapixel_snippet_id || undefined;

    useEffect(() => {
        // Load the Meta Pixel base script
        const loadPixel = () => {
            if (window.fbq) return;

            (function (f: any, b, e: any, v?:any, n?:any, t?:any, s?:any) {
                if (f.fbq) return;
                n = f.fbq = function () {
                    n.callMethod
                        ? n.callMethod.apply(n, arguments)
                        : n.queue.push(arguments);
                };
                if (!f._fbq) f._fbq = n;
                n.push = n;
                n.loaded = true;
                n.version = '2.0';
                n.queue = [];
                t = b.createElement(e);
                t.async = true;
                t.src = v;
                s = b.getElementsByTagName(e)[0];
                s.parentNode!.insertBefore(t, s);
            })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

            // Type assertion
            if (typeof window.fbq === 'function') {
                (window.fbq as (...args: any[]) => void)('init', pixelId);
                (window.fbq as (...args: any[]) => void)('track', 'PageView');
            }
        };

        const handleRouteChange = () => {
            if (typeof window.fbq === 'function') {
                window.fbq('track', 'PageView');
            }
        };

        if(pixelId) {
            loadPixel();
            router.events.on('routeChangeComplete', handleRouteChange);
            return () => {
                router.events.off('routeChangeComplete', handleRouteChange);
            };
        }
    }, [router.events, pixelId]);

    // noscript fallback
    return pixelId ? <noscript
        dangerouslySetInnerHTML={{
            __html: `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1"/>`,
        }}
    /> : <></>
}

export default MetaPixelCode;